module.exports = {
	"name": "WP-API Testbed",
	"description": "Just another WordPress site",
	"url": "http://wpapi.loc/wp",
	"home": "http://wpapi.loc",
	"namespaces": [
		"wp/v2",
		"oembed/1.0"
	],
	"authentication": {
		"oauth1": {
			"request": "http://wpapi.loc/oauth1/request",
			"authorize": "http://wpapi.loc/oauth1/authorize",
			"access": "http://wpapi.loc/oauth1/access",
			"version": "0.1"
		}
	},
	"routes": {
		"/": {
			"namespace": "",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"namespace": {
							"required": false
						},
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/posts": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						},
						"page": {
							"required": false
						},
						"per_page": {
							"required": false
						},
						"search": {
							"required": false
						},
						"after": {
							"required": false
						},
						"author": {
							"required": false
						},
						"author_exclude": {
							"required": false
						},
						"before": {
							"required": false
						},
						"exclude": {
							"required": false
						},
						"include": {
							"required": false
						},
						"offset": {
							"required": false
						},
						"order": {
							"required": false
						},
						"orderby": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"filter": {
							"required": false
						},
						"categories": {
							"required": false
						},
						"tags": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST"
					],
					"args": {
						"date": {
							"required": false
						},
						"date_gmt": {
							"required": false
						},
						"password": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"title": {
							"required": false
						},
						"content": {
							"required": false
						},
						"author": {
							"required": false
						},
						"excerpt": {
							"required": false
						},
						"featured_media": {
							"required": false
						},
						"comment_status": {
							"required": false
						},
						"ping_status": {
							"required": false
						},
						"format": {
							"required": false
						},
						"sticky": {
							"required": false
						},
						"categories": {
							"required": false
						},
						"tags": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/posts/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST",
				"PUT",
				"PATCH",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST",
						"PUT",
						"PATCH"
					],
					"args": {
						"date": {
							"required": false
						},
						"date_gmt": {
							"required": false
						},
						"password": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"title": {
							"required": false
						},
						"content": {
							"required": false
						},
						"author": {
							"required": false
						},
						"excerpt": {
							"required": false
						},
						"featured_media": {
							"required": false
						},
						"comment_status": {
							"required": false
						},
						"ping_status": {
							"required": false
						},
						"format": {
							"required": false
						},
						"sticky": {
							"required": false
						},
						"categories": {
							"required": false
						},
						"tags": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {
						"force": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/posts/(?P<parent>[\\d]+)/revisions": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/posts/(?P<parent>[\\d]+)/revisions/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {}
				}
			]
		},
		"/wp/v2/pages": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						},
						"page": {
							"required": false
						},
						"per_page": {
							"required": false
						},
						"search": {
							"required": false
						},
						"after": {
							"required": false
						},
						"author": {
							"required": false
						},
						"author_exclude": {
							"required": false
						},
						"before": {
							"required": false
						},
						"exclude": {
							"required": false
						},
						"include": {
							"required": false
						},
						"menu_order": {
							"required": false
						},
						"offset": {
							"required": false
						},
						"order": {
							"required": false
						},
						"orderby": {
							"required": false
						},
						"parent": {
							"required": false
						},
						"parent_exclude": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"filter": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST"
					],
					"args": {
						"date": {
							"required": false
						},
						"date_gmt": {
							"required": false
						},
						"password": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"parent": {
							"required": false
						},
						"title": {
							"required": false
						},
						"content": {
							"required": false
						},
						"author": {
							"required": false
						},
						"excerpt": {
							"required": false
						},
						"featured_media": {
							"required": false
						},
						"comment_status": {
							"required": false
						},
						"ping_status": {
							"required": false
						},
						"menu_order": {
							"required": false
						},
						"template": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/pages/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST",
				"PUT",
				"PATCH",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST",
						"PUT",
						"PATCH"
					],
					"args": {
						"date": {
							"required": false
						},
						"date_gmt": {
							"required": false
						},
						"password": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"parent": {
							"required": false
						},
						"title": {
							"required": false
						},
						"content": {
							"required": false
						},
						"author": {
							"required": false
						},
						"excerpt": {
							"required": false
						},
						"featured_media": {
							"required": false
						},
						"comment_status": {
							"required": false
						},
						"ping_status": {
							"required": false
						},
						"menu_order": {
							"required": false
						},
						"template": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {
						"force": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/pages/(?P<parent>[\\d]+)/revisions": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/pages/(?P<parent>[\\d]+)/revisions/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {}
				}
			]
		},
		"/wp/v2/media": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						},
						"page": {
							"required": false
						},
						"per_page": {
							"required": false
						},
						"search": {
							"required": false
						},
						"after": {
							"required": false
						},
						"author": {
							"required": false
						},
						"author_exclude": {
							"required": false
						},
						"before": {
							"required": false
						},
						"exclude": {
							"required": false
						},
						"include": {
							"required": false
						},
						"offset": {
							"required": false
						},
						"order": {
							"required": false
						},
						"orderby": {
							"required": false
						},
						"parent": {
							"required": false
						},
						"parent_exclude": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"filter": {
							"required": false
						},
						"media_type": {
							"required": false
						},
						"mime_type": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST"
					],
					"args": {
						"date": {
							"required": false
						},
						"date_gmt": {
							"required": false
						},
						"password": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"title": {
							"required": false
						},
						"author": {
							"required": false
						},
						"comment_status": {
							"required": false
						},
						"ping_status": {
							"required": false
						},
						"alt_text": {
							"required": false
						},
						"caption": {
							"required": false
						},
						"description": {
							"required": false
						},
						"post": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/media/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST",
				"PUT",
				"PATCH",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST",
						"PUT",
						"PATCH"
					],
					"args": {
						"date": {
							"required": false
						},
						"date_gmt": {
							"required": false
						},
						"password": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"status": {
							"required": false
						},
						"title": {
							"required": false
						},
						"author": {
							"required": false
						},
						"comment_status": {
							"required": false
						},
						"ping_status": {
							"required": false
						},
						"alt_text": {
							"required": false
						},
						"caption": {
							"required": false
						},
						"description": {
							"required": false
						},
						"post": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {
						"force": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/types": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/types/(?P<type>[\\w-]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/statuses": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/statuses/(?P<status>[\\w-]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/taxonomies": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						},
						"type": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/taxonomies/(?P<taxonomy>[\\w-]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/categories": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						},
						"page": {
							"required": false
						},
						"per_page": {
							"required": false
						},
						"search": {
							"required": false
						},
						"exclude": {
							"required": false
						},
						"include": {
							"required": false
						},
						"order": {
							"required": false
						},
						"orderby": {
							"required": false
						},
						"hide_empty": {
							"required": false
						},
						"parent": {
							"required": false
						},
						"post": {
							"required": false
						},
						"slug": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST"
					],
					"args": {
						"description": {
							"required": false
						},
						"name": {
							"required": true
						},
						"slug": {
							"required": false
						},
						"parent": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/categories/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST",
				"PUT",
				"PATCH",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST",
						"PUT",
						"PATCH"
					],
					"args": {
						"description": {
							"required": false
						},
						"name": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"parent": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {
						"force": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/tags": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						},
						"page": {
							"required": false
						},
						"per_page": {
							"required": false
						},
						"search": {
							"required": false
						},
						"exclude": {
							"required": false
						},
						"include": {
							"required": false
						},
						"offset": {
							"required": false
						},
						"order": {
							"required": false
						},
						"orderby": {
							"required": false
						},
						"hide_empty": {
							"required": false
						},
						"post": {
							"required": false
						},
						"slug": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST"
					],
					"args": {
						"description": {
							"required": false
						},
						"name": {
							"required": true
						},
						"slug": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/tags/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST",
				"PUT",
				"PATCH",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST",
						"PUT",
						"PATCH"
					],
					"args": {
						"description": {
							"required": false
						},
						"name": {
							"required": false
						},
						"slug": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {
						"force": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/users": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						},
						"page": {
							"required": false
						},
						"per_page": {
							"required": false
						},
						"search": {
							"required": false
						},
						"exclude": {
							"required": false
						},
						"include": {
							"required": false
						},
						"offset": {
							"required": false
						},
						"order": {
							"required": false
						},
						"orderby": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"roles": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST"
					],
					"args": {
						"username": {
							"required": true
						},
						"name": {
							"required": false
						},
						"first_name": {
							"required": false
						},
						"last_name": {
							"required": false
						},
						"email": {
							"required": true
						},
						"url": {
							"required": false
						},
						"description": {
							"required": false
						},
						"nickname": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"roles": {
							"required": false
						},
						"password": {
							"required": true
						},
						"capabilities": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/users/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST",
				"PUT",
				"PATCH",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST",
						"PUT",
						"PATCH"
					],
					"args": {
						"username": {
							"required": false
						},
						"name": {
							"required": false
						},
						"first_name": {
							"required": false
						},
						"last_name": {
							"required": false
						},
						"email": {
							"required": false
						},
						"url": {
							"required": false
						},
						"description": {
							"required": false
						},
						"nickname": {
							"required": false
						},
						"slug": {
							"required": false
						},
						"roles": {
							"required": false
						},
						"password": {
							"required": false
						},
						"capabilities": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {
						"force": {
							"required": false
						},
						"reassign": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/users/me": {
			"namespace": "wp/v2",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/comments": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						},
						"page": {
							"required": false
						},
						"per_page": {
							"required": false
						},
						"search": {
							"required": false
						},
						"after": {
							"required": false
						},
						"author": {
							"required": false
						},
						"author_exclude": {
							"required": false
						},
						"author_email": {
							"required": false
						},
						"before": {
							"required": false
						},
						"exclude": {
							"required": false
						},
						"include": {
							"required": false
						},
						"karma": {
							"required": false
						},
						"offset": {
							"required": false
						},
						"order": {
							"required": false
						},
						"orderby": {
							"required": false
						},
						"parent": {
							"required": false
						},
						"parent_exclude": {
							"required": false
						},
						"post": {
							"required": false
						},
						"status": {
							"required": false
						},
						"type": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST"
					],
					"args": {
						"author": {
							"required": false
						},
						"author_email": {
							"required": false
						},
						"author_name": {
							"required": false
						},
						"author_url": {
							"required": false
						},
						"content": {
							"required": false
						},
						"date": {
							"required": false
						},
						"date_gmt": {
							"required": false
						},
						"karma": {
							"required": false
						},
						"parent": {
							"required": false
						},
						"post": {
							"required": false
						},
						"status": {
							"required": false
						},
						"type": {
							"required": false
						}
					}
				}
			]
		},
		"/wp/v2/comments/(?P<id>[\\d]+)": {
			"namespace": "wp/v2",
			"methods": [
				"GET",
				"POST",
				"PUT",
				"PATCH",
				"DELETE"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"context": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"POST",
						"PUT",
						"PATCH"
					],
					"args": {
						"author": {
							"required": false
						},
						"author_email": {
							"required": false
						},
						"author_name": {
							"required": false
						},
						"author_url": {
							"required": false
						},
						"content": {
							"required": false
						},
						"date": {
							"required": false
						},
						"date_gmt": {
							"required": false
						},
						"karma": {
							"required": false
						},
						"parent": {
							"required": false
						},
						"post": {
							"required": false
						},
						"status": {
							"required": false
						},
						"type": {
							"required": false
						}
					}
				},
				{
					"methods": [
						"DELETE"
					],
					"args": {
						"force": {
							"required": false
						}
					}
				}
			]
		},
		"/oembed/1.0": {
			"namespace": "oembed/1.0",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"namespace": {
							"required": false
						},
						"context": {
							"required": false
						}
					}
				}
			]
		},
		"/oembed/1.0/embed": {
			"namespace": "oembed/1.0",
			"methods": [
				"GET"
			],
			"endpoints": [
				{
					"methods": [
						"GET"
					],
					"args": {
						"url": {
							"required": true
						},
						"format": {
							"required": false
						},
						"maxwidth": {
							"required": false
						}
					}
				}
			]
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/wpapi/lib/data/endpoint-response.json
 ** module id = 222
 ** module chunks = 0
 **/